const getQuestionIdMap = (gradeArray) => {
  let questionIdMap = {};
  gradeArray.forEach((section) => {
    section.Grade.forEach((question) => {
      questionIdMap[question.questionId] = question;
    });
  });
  return questionIdMap;
};

const fetchCaseGrade = async (
  examGuid,
  route,
  userData,
  displayAuthenticationError
) => {
  return await fetch(`${route}/grading.webapi`, {
    method: "POST",
    headers: {
      Token: userData.Token,
      "Content-Type": "text/plain",
    },
    body: JSON.stringify({
      guid: examGuid,
    }),
  })
    .then((response) => {
      if (response.status === 401) {
        displayAuthenticationError();
        throw new Error("Authentication Error");
      } else {
        return response.json();
      }
    })
    .then((response) => {
      console.log(response);
      let questionIdMap = getQuestionIdMap(response.Grade);

      // Add question numbers to each question
      let currentQuestionNumber = 1;

      response.Sections.forEach((section, sectionIndex) => {
        let initialSectionQuestionNumber = currentQuestionNumber;
        section.Elements.forEach((element, elementIndex) => {
          if (element.type === "input") {
            element.questionList.forEach((question, questionIndex) => {
              if (question.questionId) {
                question.questionNumber = currentQuestionNumber;
                currentQuestionNumber++;
              }
            });
          } else if (element.questionId) {
            element.questionNumber = currentQuestionNumber;
            currentQuestionNumber++;
          }
        });
        section.questionNumberStart = initialSectionQuestionNumber;
        section.questionNumberEnd = currentQuestionNumber - 1;
      });

      return {
        gradingData: response,
        questionIdMap,
      };
    });
};

export default fetchCaseGrade;
